import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect } from 'react';
import MeetingController from './MeetingController';
import PreviewMeeting from './PreviewMeeting';
import { BackgroudAppContext, useBackgroundAppContext, usePostBackgroundMessage, } from '../../iframe/useBackgroundApp';
import { refreshToken } from '../../constants/leadinConfig';
import { ProxyMessages } from '../../iframe/integratedMessages';
import LoadingBlock from '../Common/LoadingBlock';
import { getOrCreateBackgroundApp } from '../../utils/backgroundAppUtils';
function MeetingEdit({ attributes: { url }, isSelected, setAttributes, preview = true, origin = 'gutenberg', }) {
    const isBackgroundAppReady = useBackgroundAppContext();
    const monitorFormPreviewRender = usePostBackgroundMessage();
    const handleChange = (newUrl) => {
        setAttributes({
            url: newUrl,
        });
    };
    useEffect(() => {
        monitorFormPreviewRender({
            key: ProxyMessages.TrackMeetingPreviewRender,
            payload: {
                origin,
            },
        });
    }, [origin]);
    return !isBackgroundAppReady ? (_jsx(LoadingBlock, {})) : (_jsxs(Fragment, { children: [(isSelected || !url) && (_jsx(MeetingController, { url: url, handleChange: handleChange })), preview && url && _jsx(PreviewMeeting, { url: url })] }));
}
export default function MeetingsEditContainer(props) {
    return (_jsx(BackgroudAppContext.Provider, { value: refreshToken && getOrCreateBackgroundApp(refreshToken), children: _jsx(MeetingEdit, { ...props }) }));
}
